import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import Layout from '../../../layout/Layout';
import getRoleDetails from '../../../thunks/roles/getRoleDetails';
import PermissionsGate from '../../../components/PermissionsGate/PermissionsGate';
import AccessDenied from '../../../components/AccessDenied/AccessDenied';
import { permissions } from '../../../common/permissionGroup';
import RoleDetailsSkeleton from './RoleDetailsSkeleton';
import RoleCard from '../../../components/RoleCard/RoleCard';
import RoleModal from '../Roles/components/RoleModal';
import RoleUsersCard from './components/RoleUsersCard';
import routes from '../../../router/routes';

const containerClassName = 'flex flex-row w-full';
const itemClassName = 'px-[15px]';

const RoleDetail = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [roleModalVisibility, setRoleModalVisibility] = useState(false);
  const [activePermissions, setActivePermissions] = useState([]);
  const { getRoleDetails: { loading, role, role: { users } = {} } = {} } = useSelector((state) => ({
    getRoleDetails: state.getRoleDetails
  }), shallowEqual);

  useEffect(() => {
    dispatch(getRoleDetails(id));
  }, []);

  const breadcrumbs = {
    pageTitle: 'Role Overview',
    history: [
      {
        title: 'Home',
        onClick: () => navigate('/')
      },
      {
        title: 'User management',
      },
      {
        title: 'Roles',
        onClick: () => navigate(routes.ROLES)
      },
      {
        title: role?.name,
      }
    ]
  };

  return (
    <Layout breadcrumbs={breadcrumbs}>
      {loading && !role ? <RoleDetailsSkeleton /> : (
        <PermissionsGate can={permissions.ROLES_READ} errorComponent={<AccessDenied />}>
          <div className={containerClassName}>
            <div className={`flex flex-1 ${itemClassName}`}>
              <RoleCard item={role} onButtonEdit={() => setRoleModalVisibility(true)} />
            </div>
            <div className={`flex flex-[3] ${itemClassName}`}>
              <RoleUsersCard users={users} />
            </div>
          </div>
          <RoleModal
            visible={roleModalVisibility}
            toggleVisible={() => setRoleModalVisibility(false)}
            editRole={role}
            activePermissions={activePermissions}
            setActivePermissions={setActivePermissions}
          />
        </PermissionsGate>
      )}
    </Layout>
  );
};

RoleDetail.propTypes = {};

RoleDetail.defaultProps = {};

export default RoleDetail;
